import * as React from "react";

import { NavMain } from "@/components/layouts/sidebar-left/nav-main";
import { NavUser } from "@/components/layouts/sidebar-left/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar";

import { useAppSelector } from "@/lib/store";

export function SidebarLeft({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { state } = useSidebar();
  const user = useAppSelector((state) => state.auth.user);

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader className="h-16 border-b border-sidebar-border flex item-center justify-center">
        <a href="/" className="flex items-center gap-2">
          {state === "collapsed" ? (
            <img src="/icon.svg" alt="Shyne Logo" className="h-9 dark:invert dark:brightness-0" />
          ) : (
            <img src="/logo.png" alt="Shyne Logo" className="h-9 dark:invert dark:brightness-0" />
          )}
        </a>
      </SidebarHeader>
      <SidebarContent>
        <NavMain />
        {/* <NavProjects projects={data.projects} /> */}
      </SidebarContent>
      <SidebarFooter>
          {user && <NavUser user={user} />}
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
